<template>
  <div class="card p-2" style="min-height: 200px">
    <div class="table-responsive">
      <table class="table table-bordered">
        <thead>
        <tr>
          <th class="text-left">Offboarding Type</th>
          <th class="text-center">Details Reason</th>
          <th class="text-center">Joining Date</th>
          <th class="text-center">Application Date</th>
          <th class="text-center">Last Working Date</th>
          <th class="text-center">Recommendation</th>
          <th class="text-center">Attachment</th>
          <th class="text-center">Status</th>
          <th class="text-center">Action</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(item, i) in tableItems" :key="i">
          <td class="text-left">{{ item.off_boarding_type }}</td>
          <td class="text-left">{{ item.details_reason }}</td>
          <td class="text-left">{{ item.formatted_employment_date_of_joining }}</td>
          <td class="text-left">{{ item.created_at_formatted }}</td>
          <td class="text-left">{{ item.last_working_date_formatted }}</td>
          <td class="text-left">{{ item.recommendation_type }}</td>
          <td class="text-left">
            <button v-if="item.attachments.length > 0" class="btn btn-primary btn-sm"
                    style="cursor: pointer"
                    @click="viewAttachments(item.attachments)"
            >
              <i class="fas fa-eye"></i>
              View
            </button>
            <span v-else class="badge btn-danger">
               No attachments
            </span>
          </td>
          <td class="text-left">{{ item.status }}</td>

          <td class="text-center">
            <button v-if="['pending'].includes(item.status)" class="btn btn-primary btn-sm m-1"
                    @click="openEditModal(item)"
                    style="cursor: pointer"
            >
              <i class="fas fa-eye"></i>
            </button>

            <button class="btn btn-primary btn-sm"
                    @click="openClearanceModal(item)"
                    style="cursor: pointer"
            >
              <i class="fas fa-eye"></i>
            </button>

          </td>
        </tr>
        </tbody>
      </table>
      <p v-if="tableItems.length < 0" class="text-center mt-5">No data</p>
    </div>

    <EmployeeOffBoardingModal
        v-if="store.state.isModalOpenTwo"
        :formData="formData"
        :contactInfo="contactInfo"
        @getOffBoardingList="getOffBoardingList"
    />

    <ViewAttachment
        ref="viewAttachmentRef"
        :attachments="modalAttachments"
    />

    <EmployeeOffBoardingClearanceStatusModal
        v-if="store.state.isModalOpenFour"
        :clearanceData="clearanceData"
    />

  </div>
</template>

<script setup>
import handleHrPayroll from "@/services/modules/hrPayroll/hrPayroll";
import {useStore} from "vuex";
import {useRoute} from "vue-router";
import EmployeeOffBoardingModal from '@/components/molecule/company/hrm-payroll/employee-off-boarding/EmployeeOffBoardingModal.vue';
import {ref} from "vue";
import ViewAttachment from '@/views/page/company/ngo/voucher/payment/ViewAttachmentModal.vue'
import EmployeeOffBoardingClearanceStatusModal from '@/components/molecule/company/hrm-payroll/employee-off-boarding/EmployeeOffBoardingClearanceStatusModal.vue';

const props  = defineProps({
  tableItems     : Object,
  formData:{
    type:Object,
    default:{}
  },
  getOffBoardingList:{
    type:Function
  },
  contactInfo: {
    type: Object
  }
});

const {
  fetchSingleEmployeeOffBoarding,
  fetchSingleEmployeeOffBoardingRecommended
} = handleHrPayroll()
const store = useStore();
const route = useRoute();
const modalAttachments = ref([]);
const clearanceData = ref([]);
const viewAttachmentRef = ref();

const viewAttachments = (attachments) => {
  modalAttachments.value = [];
  modalAttachments.value = attachments;
  viewAttachmentRef.value && viewAttachmentRef.value.toggleModal();
}

const openEditModal = (item) => {
  let query = `?company_id=${route.params.companyId}`;
  fetchSingleEmployeeOffBoarding(item.id, query).then(res => {
    if (!res.status){
      return
    }

    let data = res.data;
    props.formData.contact_profile_id = data.contact_profile_id;
    props.formData.off_boarding_type_id = data.off_boarding_type_id;
    props.formData.off_boarding_type = data.off_boarding_type;
    props.formData.details_reason = data.details_reason;
    props.formData.last_working_date = data.last_working_date;
    props.formData.is_edit = true;
    props.formData.attachments = data.attachments;
    props.formData.id = data.id;
  });

  store.state.isModalOpenTwo = true
}

const openClearanceModal = (item) => {
  let query = `?company_id=${route.params.companyId}`;
  fetchSingleEmployeeOffBoardingRecommended(item.id, query).then(res => {
    if (!res.status){
      return
    }
    clearanceData.value = res.data;
    store.state.isModalOpenFour = true
  });
}

</script>
